import styled from 'styled-components';

export const StyledBankingOptionLabel = styled.span`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
`;
